import React from "react";

import Comand from "../../../Comand";
import Img from "../../../Img";

//Imagenes
import Img_One from "./../../../../sources/imgs/WEBMII/WEBMII_01.png";
import Img_Two from "./../../../../sources/imgs/WEBMII/WEBMII_02.png";
import Img_Three from "./../../../../sources/imgs/WEBMII/WEBMII_03.png";
import Img_Four from "./../../../../sources/imgs/WEBMII/WEBMII_04.png";
import Img_Five from "./../../../../sources/imgs/WEBMII/WEBMII_05.png";

import icon_directory_pink from "./../../../../sources/icons/icon-directory-pink.svg";
import icon_directory from "./../../../../sources/icons/icon-directory.svg";

export default function WEBMII (props) {
    return (
        <>
            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                <span className="span-pink"> WEBMII.<span className="span-pink cursor">_</span>
                </span>
            </h3>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Introducción a Webmii.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Webmii</span> es un <span className="span-pink">motor de búsqueda de personas</span> que centraliza <span className="span-white">información pública disponible en la web</span>. Al realizar una <span className="span-blue">búsqueda</span>, <span className="span-yellow">Webmii</span> genera automáticamente una página de <span className="span-blue">resultados</span> que incluye <span className="span-pink">datos recopilados de otros sitios web</span>. La <span className="span-white">información presentada</span> es <span className="span-blue">pública</span> y proviene de <span className="span-blue">diversas fuentes en línea</span>. Es importante destacar que <span className="span-yellow">Webmii</span> <span className="span-blue">no controla ni modifica la información publicada</span>  por <span className="span-pink">otros sitios web</span>.
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Sitio oficial de Webmii.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Webmii</span> puede ser <span className="span-blue">consultado</span> y <span className="span-blue">utilizado</span> desde su <span className="span-white">sitio web oficial</span>.
            </p>

            <p>
                <span className="span-pink">Consultar</span> la sitio: <a href="https://webmii.com/" className="span-white">Webmii</a>.
            </p>

            <p>
                Puedes <span className="span-pink">obtener</span> el <span className="span-white">enlace</span> al sitio de <span className="span-yellow">Webmii</span> en <span className="span-pink">portapapeles</span> tambien:
            </p>

            <Comand
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                code = "https://webmii.com/"
            />

            <p>
                <span className="span-pink">Imagen</span> de <span className="span-white">sitio oficial</span>:
            </p>

            <Img
                img = {Img_One}
                alt = {"Imagen 1. WEBMII."}
                title = {"Descripcción de imagen."}
                text = {"1. Pagina oficial de WEBMII."}
            />

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Caracteristicas de Webmii.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Algunas de las <span className="span-white">caracteristicas</span> de la <span className="span-pink">herramienta</span> de <span className="span-yellow">Webmii</span> son:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <b className="span-pink">Puntuación de visibilidad:</b> <span className="span-yellow">Webmii</span> asigna una <span className="span-white">puntuación</span> que indica la <span className="span-blue">visibilidad de una persona</span> en <span className="span-pink">Internet</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <b className="span-pink">Aplicación móvil:</b> <span className="span-yellow">Webmii</span> está disponible para <span className="span-white">dispositivos iOS</span>, permitiendo buscar personas directamente desde la <span className="span-blue">lista de contactos</span> y <span className="span-blue">comparar puntuaciones de visibilidad</span>.
                    </p>
                </li>
                <li>
                    <p>
                        <b className="span-pink">Widget de búsqueda:</b> La <span className="span-pink">aplicación</span> ofrece un <i className="span-white">widget</i> que permite realizar <span className="span-pink">búsquedas</span> desde la <span className="span-blue">pantalla de inicio del dispositivo</span>.
                    </p>
                </li>
            </ol>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Utilización de Webmii.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <b className="span-blue">
                    1. Ingresar nombre de usuario a buscar información.
                </b>
            </p>

            <p>
                En el <span className="span-white">campo de búsqueda</span>, escribe el <span className="span-pink">nombre completo</span> de la <span className="span-white">persona</span> que deseas <span className="span-pink">encontrar</span>.
            </p>

            <p>
                Un <span className="span-pink">ejemplo</span>:
            </p>

            <Img
                img = {Img_Two}
                alt = {"Imagen 2. WEBMII."}
                title = {"Descripcción de imagen."}
                text = {"2. Busqueda de usuario en WEBMII."}
            />

            <p>
                En la <span className="span-pink">busqueda</span> del <span className="span-white">ejemplo anterior</span>, se colocó un <span className="span-blue">nombre común</span>, <span className="span-blue">sin conocimiento</span> y <span className="span-blue">familiaridad</span> de <span className="span-pink">usuario</span>.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> Para <span className="span-pink">obtener</span> <span className="span-white">resultados más precisos</span>, puedes <span className="span-white">agregar</span> <span className="span-pink">palabras clave relacionadas</span>, como la <span className="span-blue">profesión</span> o la <span className="span-blue">ubicación</span>.
            </p>

            <p>
                <b className="span-blue">
                    2. Revisar la información obtenida.
                </b>
            </p>

            <p>
                <span className="span-yellow">Webmii</span> mostrará una <span className="span-white">página de resultados</span>  que incluyen <span className="span-blue">fotografías</span>, <span className="span-blue">etiquetas</span>, <span className="span-blue">redes sociales</span> y <span className="span-blue">otros datos públicos</span> relacionados con la <span className="span-pink">persona buscada</span>.
            </p>

            <Img
                img = {Img_Three}
                alt = {"Imagen 3. WEBMII."}
                title = {"Descripcción de imagen."}
                text = {"3. Información de usuario obtenida en WEBMII."}
            />

            <p>
                <span className="span-yellow">Webmii</span> nos devolverá si <span className="span-pink">encuentra</span>, <span className="span-blue">redes sociales</span> y <span className="span-blue">paginas</span> en los cuales se encuentre <span className="span-white">registrado</span> el <span className="span-pink">nombre del usuario</span> en <span className="span-white">paginas publicas</span>.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> En nuestro <span className="span-pink">ejemplo</span>, <span className="span-yellow">Webmii</span> logró <span className="span-white">encontrar</span> las <span className="span-pink">redes del usuario</span> de <span className="span-blue">Twitter</span> e <span className="span-blue">Instagram</span>.
            </p>

            <Img
                img = {Img_Four}
                alt = {"Imagen 4. WEBMII."}
                title = {"Descripcción de imagen."}
                text = {"4. Información de usuario obtenida en WEBMII."}
            />

            <p>
                <span className="span-yellow">Webmii</span> tambien realiza busquedas en <span className="span-blue">paginas</span> y <span className="span-blue">sitios de información</span> y <span className="span-blue">documentación</span> donde encuentra <span className="span-white">parecidos</span> o <span className="span-white">parecidos</span> con la <span className="span-pink">busqueda del usuario</span>.
            </p>

            <Img
                img = {Img_Five}
                alt = {"Imagen 5. WEBMII."}
                title = {"Descripcción de imagen."}
                text = {"5. Información de usuario obtenida en WEBMII."}
            />

            <p>
                Finalmente, <span className="span-yellow">Webmii</span> devolverá <span className="span-pink">busquedas</span> desde <span className="span-white">Google Search</span>.
            </p>

            <p>
                <span className="span-yellow">Nota:</span> Si realizamos <span className="span-pink">busquedas</span>, <span className="span-yellow">Webmii</span> podria encontrar <span className="span-blue">multiples usuarios similares</span>, por lo que es <span className="span-white">importante</span> filtrar <span className="span-blue">información util</span> y <span className="span-blue">optima</span> que encontremos. 
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Consideraciones importantes de Webmii.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                <span className="span-yellow">Webmii</span> <span className="span-white">no almacena</span> ni <span className="span-white">controla la información</span> que muestra; simplemente la <span className="span-pink">recopila</span> de <span className="span-blue">fuentes públicas</span> disponibles en la <span className="span-blue">web</span>. Por lo tanto, si deseas <span className="span-blue">modificar</span> o <span className="span-blue">eliminar</span> algún dato, deberás <span className="span-white">contactar directamente al sitio web</span> de origen donde se publicó la <span className="span-pink">información</span>.
            </p>

            <p>
                <span className="span-pink">Recuerda</span>, es <span className="span-white">fundamental</span> utilizar <span className="span-yellow">Webmii</span> de manera <span className="span-blue">ética</span> y <span className="span-blue">moral</span>:
            </p>

            <h3 className="span-blue">
                <img className="icon-subtitle" src={icon_directory} alt=""/>
                <span className="span-blue"> Recursos extra de Webmii.<span className="span-blue cursor">_</span>
                </span>
            </h3>

            <p>
                Si deseas <span className="span-pink">conocer</span> más sobre <span className="span-yellow">Webmmi</span>, puedes consutar <span className="span-white">otros recursos</span>:
            </p>

            <ol className="ol-code">
                <li>
                    <p>
                        <span className="span-pink">Tutorial de uso en video:</span> Puedes consultar el <span className="span-white">tutorial</span> de uso desde: <a className="span-white" href="https://www.youtube.com/watch?v=BYG2DJExak8" target="_blank" rel="noopener noreferrer">https://www.youtube.com/watch?v=BYG2DJExak8</a>
                    </p>
                </li>
                <li>
                    <p>
                        <span className="span-pink">Documentación técnica:</span> Si deseas una <span className="span-pink">comprensión más profunda</span>, puedes consultar la siguiente <span className="span-white">información</span>: <a className="span-white" href="https://es.scribd.com/document/632027206/EB-5-HERRAMIENTAS-PARA-BUSCAR-PERSONAS-EN-REDES-SOCIALES" target="_blank" rel="noopener noreferrer">Herramientas para Buscar Personas en Redes Sociales</a>.
                    </p>
                </li>
            </ol>

        </>
    );
}